export class LedRiskMatrixManager {
    private static instance: LedRiskMatrixManager;
    private matrix: LedRiskmatrix;

    private constructor() {
        this.matrix = LedRiskmatrix.getInstance();
    }

    public static getInstance() {
        if(!LedRiskMatrixManager.instance)
            LedRiskMatrixManager.instance = new LedRiskMatrixManager();
        
        return LedRiskMatrixManager.instance;
    }

    public addInput(input: JQuery<HTMLElement>) {
        input.on("focus", (e) => {
            const input = $(e.target);
            this.showMatrix(input);
        });
    }

    public showMatrix(input: JQuery<HTMLElement>) {
        this.matrix.show(input);
    }
}

class LedRiskmatrix {
    private static instance: LedRiskmatrix;
    private matrix: JQuery<HTMLElement>;
    private inputOpened: JQuery<HTMLElement>|null = null;
    private modal: JQuery<HTMLElement>;

    private constructor() {
        this.modal = $("#led-riskmatrix-modal");
        this.matrix = this.modal.find(".led-riskmatrix-container").html($(this.template()).html());

        this.matrix.find(".risk-code").on("click", (e) => {
            this.matrix.find("[data-checked=1]").attr("data-checked", "0");

            const element = $(e.target);
            element.attr("data-checked", "1");
            
            const value = element.attr("data-value") as string;
            let risk = element.attr("data-risk") as string;

            if(this.inputOpened) {
                this.inputOpened.attr("data-risk", risk);
                this.inputOpened.val(`${value}`);
                this.inputOpened.text(`${value}`);
                
                const event = new CustomEvent("riskmatrix-change", {detail: value});
                this.inputOpened.get(0).dispatchEvent(event);
            }

            this.hide();
        });
    }

    public static getInstance(): LedRiskmatrix {
        if(!LedRiskmatrix.instance)
            LedRiskmatrix.instance = new LedRiskmatrix();
        
        return LedRiskmatrix.instance;
    }

    public show(input: JQuery<HTMLElement>): void {
        // Set the value
        this.setValue(input.data("value") as string);

        // Save input opened
        this.inputOpened = input;

        // Show modal
        this.modal.modal("show");
    }

    public hide(): void {
        this.inputOpened = null;
        this.modal.modal("hide");
    }

    public setValue(value: string): void {
        // Reset the choice
        this.matrix.find("[data-checked=1]").attr("data-checked", "0");

        // If the value is valid, update the matrix
        if(value !== "")
            this.matrix.find("[data-value=" + value + "]").attr("data-checked", "1");
    }

    public get element(): JQuery<HTMLElement> {
        return this.matrix;
    }

    private template(): string {
        return `
            <div>
                <table class="table table-bordered risk-matrix">
                    <thead class="thead-light">
                        <tr>
                            <th rowspan="2">Risk probability</th>
                            <th colspan="5">Risk severity</th>
                        </tr>
                        <tr>
                            <th>Catastrophic A</th>
                            <th>Hazardous B</th>
                            <th>Major C</th>
                            <th>Minor D</th>
                            <th>Negligible E</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="d-flex justify-content-between"><span>Frequent</span> <span>5</span></td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="5A" data-risk="unacceptable">5A</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="5B" data-risk="unacceptable">5B</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="5C" data-risk="unacceptable">5C</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="5D" data-risk="tolerable">5D</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="5E" data-risk="tolerable">5E</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="d-flex justify-content-between"><span>Occasional</span> <span>4</span></td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="4A" data-risk="unacceptable">4A</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="4B" data-risk="unacceptable">4B</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="4C" data-risk="tolerable">4C</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="4D" data-risk="tolerable">4D</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="4E" data-risk="tolerable">4E</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="d-flex justify-content-between"><span>Remote</span> <span>3</span></td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="3A" data-risk="unacceptable">3A</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="3B" data-risk="tolerable">3B</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="3C" data-risk="tolerable">3C</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="3D" data-risk="tolerable">3D</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="3E" data-risk="acceptable">3E</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="d-flex justify-content-between"><span>Improbable</span> <span>2</span></td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="2A" data-risk="tolerable">2A</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="2B" data-risk="tolerable">2B</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="2C" data-risk="tolerable">2C</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="2D" data-risk="acceptable">2D</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="2E" data-risk="acceptable">2E</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="d-flex justify-content-between"><span>Extremely improbable</span> <span>1</span></td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="1A" data-risk="tolerable">1A</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="1B" data-risk="acceptable">1B</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="1C" data-risk="acceptable">1C</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="1D" data-risk="acceptable">1D</div>
                            </td>
                            <td>
                                <div class="risk-code" data-checked="0" data-value="1E" data-risk="acceptable">1E</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        `;
    }
}